const audioExtensions = [
  '.m4a',
  '.mp4a',
  '.mpga',
  '.mp2',
  '.mp2a',
  '.mp3',
  '.m2a',
  '.m3a',
  '.wav',
  '.weba',
  '.aac',
  '.oga',
  '.spx',
  '.flac',
  '.alac',
  '.aiff',
  '.mp4',
  '.ape',
  '.ofr',
  '.ogg',
  '.mogg',
  '.opus',
  '.mpc',
  '.wma',
  '.wv'
];

export const audioExtensionsEnumeration = audioExtensions.join(',');
